export const makansafeConstants = {
    GENERATE_AI_IDDSI_FOOD_REQUEST: 'GENERATE_AI_IDDSI_FOOD_REQUEST',
    GENERATE_AI_IDDSI_FOOD_SUCCESS: 'GENERATE_AI_IDDSI_FOOD_SUCCESS',
    GENERATE_AI_IDDSI_FOOD_FAILURE: 'GENERATE_AI_IDDSI_FOOD_FAILURE',

    REPORT_USERS_REQUEST: 'REPORT_USERS_REQUEST',
    REPORT_USERS_SUCCESS: 'REPORT_USERS_SUCCESS',
    REPORT_USERS_FAILURE: 'REPORT_USERS_FAILURE',

    CREATE_IDDSI_ACCOUNT_REQUEST: 'CREATE_IDDSI_ACCOUNT_REQUEST',
    CREATE_IDDSI_ACCOUNT_SUCCESS: 'CREATE_IDDSI_ACCOUNT_SUCCESS',
    CREATE_IDDSI_ACCOUNT_FAILURE: 'CREATE_IDDSI_ACCOUNT_FAILURE',

    DEACTIVATE_USER_ACCOUNT_REQUEST: 'DEACTIVATE_USER_ACCOUNT_REQUEST',
    DEACTIVATE_USER_ACCOUNT_SUCCESS: 'DEACTIVATE_USER_ACCOUNT_SUCCESS',
    DEACTIVATE_USER_ACCOUNT_FAILURE: 'DEACTIVATE_USER_ACCOUNT_FAILURE'
};